/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_Completed_SuccessInputs */



/**
* | output |
* | --- |
* | "Save project completed successfully" |
*
* @param {Save_Completed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const save_completed_success = /** @type {((inputs?: Save_Completed_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_Completed_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du projet terminé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich gespeichert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio del progetto completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar proyecto completado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目保存已成功完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの保存が正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सफलतापूर्वक पूरा हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto concluído com sucesso.")
	return /** @type {LocalizedString} */ ("Save project completed successfully")
});